<template lang="pug">
  .b-change Удалил(а) комментарий {{ name }} от {{ date }}
</template>

<script>
import utils from '@/utils/common';
import BaseStatus from '@/components/BaseStatus.vue';

export default {
  name: 'TaskChangeStatus',
  components: { BaseStatus },
  props: {
    change: Object,
  },
  computed: {
    name() {
      const user = this.change.users[0];
      return `${user.name} ${user.surname}`;
    },
    date() {
      return utils.convertDateToString(new Date(this.change.updatedAt), 'long', true, true);
    },
  },
};
</script>

<style scoped lang="scss">

</style>
